import { render, staticRenderFns } from "./PieComponent.vue?vue&type=template&id=0c05c090&scoped=true"
import script from "./PieComponent.vue?vue&type=script&lang=js"
export * from "./PieComponent.vue?vue&type=script&lang=js"
import style0 from "./PieComponent.vue?vue&type=style&index=0&id=0c05c090&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c05c090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c05c090')) {
      api.createRecord('0c05c090', component.options)
    } else {
      api.reload('0c05c090', component.options)
    }
    module.hot.accept("./PieComponent.vue?vue&type=template&id=0c05c090&scoped=true", function () {
      api.rerender('0c05c090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/PieComponent.vue"
export default component.exports